<template>
  <div
    class="nav-user-card"
    :style="{
      background: cardStyle.cardBgColor,
    }"
  >
    <CardLoginInfo
      class="nav-card-base-info"
      :login-info="loginStore.loginInfo"
      :icon-info="iconInfo"
      :icon-list="iconList.slice(0, 3)"
      :integral-info="integralInfo"
      :diamonds-info="diamondsInfo"
      :user-identity="userIdentity"
      :user-basic-report-info="userBasicReportInfo"
      :card-style="cardStyle"
      :vip-card="vipCard"
    />
    <div
      v-if="!isFamilySub"
      class="nav-card-vip-info-module"
    >
      <CardVipInfo
        :user-identity="userIdentity"
        :vip-card="vipCard"
        :login-info="loginStore.loginInfo"
        :card-style="cardStyle"
        :public-report="publicReport"
      />
      <CardSportsInfo
        :user-identity="userIdentity"
        :sport-card="sportCard"
        :login-info="loginStore.loginInfo"
        :card-style="cardStyle"
        :public-report="publicReport"
      />
    </div>
    <CardOtherInfo
      v-if="!isFamilySub"
      class="nav-card-other-info"
      :user-identity="userIdentity"
      :other-card="otherCard"
      :login-info="loginStore.loginInfo"
      :card-style="cardStyle"
      :public-report="publicReport"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useLoginStore } from '@/store';
import CardLoginInfo from './card-login-info.vue';
import CardOtherInfo from './card-other-info.vue';
import CardVipInfo from './card-vip-info.vue';
import CardSportsInfo from './card-sports-info.vue';

const loginStore = useLoginStore();
const vipCard = computed(() => loginStore.userModule?.vipCard);
const sportCard = computed(() => loginStore.userModule?.sportCard);
const integralInfo = computed(() => loginStore.userModule?.integralInfo || {});
const diamondsInfo = computed(() => loginStore.userModule?.diamondsInfo || {});
const otherCard = computed(() => loginStore.userModule?.otherCard || {});
const iconInfo = computed(() => loginStore.userModule?.iconInfo || {});
const iconList = computed(() => loginStore.userModule?.vipIconList || []);
const userBasicReportInfo = computed(() => loginStore.userModule?.userbasicReportInfo || {});
const userIdentity = computed(() => loginStore.userModule?.userIdentity || '');
const isFamilySub = computed(() => loginStore.isFamilySub);
const publicReport = computed(() => loginStore.publicReport || {});

const cardStyle = computed(() => ({
  nickColor: loginStore.cardStyle.nickColor,
  cardBgColor: loginStore.cardStyle.cardBgColor,
  fontColor: loginStore.cardStyle.fontColor,
  btnColor: loginStore.cardStyle.btnColor,
  btnFontColor: loginStore.cardStyle.btnFontColor,
}));


</script>
<style lang="scss" scoped>
.nav-user-card {
  padding: 16px 16px 0px 16px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  color: #fff;
  overflow: visible;
}
.nav-card-base-info {
  flex-shrink: 0;
  margin-bottom: 12px;
  min-height: 56px;
}
.nav-card-vip-info-module {
  overflow: visible;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 98px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.nav-card-other-info {
  flex-shrink: 0;
}
</style>


